import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { generateInfluencerForm } from "./generateInfluencerForm";

const InfluencerForm = ({ onClick  }) => {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [vanityUrl, setVanityUrl] = useState("");
  const [brandId, setBrandId] = useState("");
  const userAuth = useSelector((state) => state.auth);
  const isAdminOrSuperUser = userAuth?.userInfo?.userData?.role === "Administrator" || userAuth?.userInfo?.userData?.role === "Super User" || userAuth?.userInfo?.userData?.role === "Supervisor";

  // Dont show the page if the user is not an admin or super user
  if(!isAdminOrSuperUser)
  {
    return (<Navigate to={{pathname: "/",}}/>);
  }
  
  return (
    <div
      className="search-form-box"
      style={{
        background: "#1137535e",
        padding: "1rem",
        borderRadius: "10px",
      }}
    >
      {generateInfluencerForm(
        email,
        setEmail,
        firstName,
        setFirstName,
        lastName,
        setLastName,
        vanityUrl,
        setVanityUrl,
        brandId,
        setBrandId
      )}
      <button
        onClick={() =>
          onClick(
            email,
            firstName,
            lastName,
            vanityUrl,
            brandId
          )
        }
        className="subBtn"
      >
        <span>Submit</span>
      </button>
      
    </div>
  );
};

export default InfluencerForm;
